import { render, staticRenderFns } from "./ActiveUsers.vue?vue&type=template&id=327b456a&scoped=true"
import script from "./ActiveUsers.vue?vue&type=script&lang=js"
export * from "./ActiveUsers.vue?vue&type=script&lang=js"
import style0 from "./ActiveUsers.vue?vue&type=style&index=0&id=327b456a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327b456a",
  null
  
)

export default component.exports